<template>
  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <div
          v-if="$can('write', 'zones/services')"
          class="d-flex align-items-center justify-content-end"
        >
          <b-button
            variant="primary"
            @click="$router.push('/zones/new')"
          >
            <span
              class="text-nowrap"
            >Add Zone</span>
          </b-button>
        </div>
      </div>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loadingZones"
      >
        <b-table
          ref="refZoneListTable"
          :per-page="perPage"
          :current-page="currentPage"
          class="position-relative"
          :items="tableData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching zones found"
        >
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`light-${resolveZoneStatusVariant(data.item.status)}`"
              class="text-capitalize"
            >
              {{ data.item.status }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item
                v-if="$can('write', 'zones/services')"
                @click="goToEditZone(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-overlay>
      <div class="mx-2 mb-2">
        <b-row>

          <!-- Pagination -->
          <b-col
            cols="12"
            sm="12"
            class="d-flex align-items-center justify-content-between"
          >
            <b-form-group
              class="mb-0"
            >
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="perPageOptions"
                class="w-50"
              />
            </b-form-group>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalServices"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTable, BOverlay, BButton, VBModal, BDropdown, BDropdownItem, BBadge, BPagination, BRow, BCol,
  BFormGroup, BFormSelect,
} from 'bootstrap-vue'
import useZoneList from '@/views/zones/useZoneList'

export default {
  components: {
    BFormGroup,
    BFormSelect,
    BRow,
    BCol,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    BCard,
    BTable,
    BOverlay,
    BButton,
  },
  directives: {
    'b-modal': VBModal,
  },
  setup() {
    const {
      fetchZones,
      tableColumns,
      refZoneListTable,
      loadingZones,
      refetchData,
      goToEditZone,
      resolveZoneStatusVariant,
      tableData,
      perPage,
      totalServices,
      currentPage,
      perPageOptions,
    } = useZoneList()

    return {
      fetchZones,
      tableColumns,
      refZoneListTable,
      loadingZones,
      refetchData,
      goToEditZone,
      resolveZoneStatusVariant,
      tableData,
      perPage,
      totalServices,
      currentPage,
      perPageOptions,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
</style>
